__turbopack_context__.v({
  "EmbeddedVideo": "EmbeddedVideo-module__vK7fKG__EmbeddedVideo",
});
